const preferenceOptions = [
  {
    label: 'Off',
    value: 0,
  }, {
    label: 'On - All Jobs',
    value: 1,
  }, {
    label: 'On - Jobs Sent To',
    value: 2,
  },
];

export default preferenceOptions;



// WEBPACK FOOTER //
// ./src/constants/preferenceOptions.js